import React from "react";
import LandingPageTopNav from "views/LandingPageTopNav";
import LandingPageFooter from "views/LandingPageFooter";
import PrivacyPolicyContent from "components/PrivacyPolicyContent";
import "assets/css/trust-center.css";

function Privacy() {
  return (
    <div className="trust-center-page landing-page-font">
      <LandingPageTopNav showPricingLink={false} />
      <main className="trust-center-main">
        <div className="trust-center-container">
          <PrivacyPolicyContent />
        </div>
      </main>
      <LandingPageFooter />
    </div>
  );
}

export default Privacy;
